import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import Logo from "assets/images/cuverd-logo-footer.png";
import {
  Grid,
  useTheme,
  Typography,
  useMediaQuery,
  Button,
} from "@mui/material";
import { Box } from "@mui/system";
import { Link } from "react-router-dom";
import { homeActions } from "actions";
import MessageDialog from "pages/SearchMedication/MessageDialog";
import { config } from "../constants";
import version from "../version.json";
import instaIcon from "assets/images/insta.png";
import fbIcon from "assets/images/fb.png";
import youtubeIcon from "assets/images/youtube.png";
import twitterIcon from "assets/images/x.svg";
import linkedInIcon from "assets/images/linkedin.png";

const FooterView = (props) => {
  const {
    infoStatus,
    getAppSettingsIdentity,
    resetSettingsIdentity,
    organizationLogo,
    organizationInfo,
  } = props;

  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [showAppInfo, setShowAppInfo] = useState(false);
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const legitscript2 = useRef(null);
  const widgetEnabled = sessionStorage.getItem("widgetEnabled");
  const isHCPTemplate =
    organizationInfo?.type?.toLowerCase() === "h" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

  useEffect(() => {
    if (infoStatus) {
      setShowAppInfo(infoStatus);
    }
  }, [infoStatus]);

  useEffect(() => {
    setTimeout(() => {
      const script = document.createElement("a");
      const url = "https://legitscript.com";

      script.href = url;
      script.innerHTML =
        '<img src="https://static.legitscript.com/seals/16560938.png" alt="LegitScript approved" width="140" height="100" border="0" />';

      legitscript2.current?.appendChild(script);
    }, 1000);
  }, []);

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      className="homeFooter"
      sx={{
        padding: matchesSm ? "24px" : undefined,
        backgroundColor: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}  !important`,
        display: widgetEnabled?.toLowerCase() === "y" ? "none" : undefined,
      }}
    >
      <Grid
        item
        sx={{
          marginBottom: "25px",
          marginLeft: "auto",
          marginRight: "auto",
          display: matchesSm ? "block" : "flex",
        }}
      >
        <Box
          component={Link}
          to="/terms-and-conditions"
          sx={{ textDecoration: "none" }}
        >
          <Typography
            component={matchesSm ? "div" : "span"}
            sx={{
              color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
            }}
            variant="h3LatoBold"
          >
            Terms and Conditions
          </Typography>
        </Box>
        <Box
          mx={3}
          component="span"
          sx={{
            color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
            visibility: { xs: "hidden", sm: "visible" },
          }}
        >
          |
        </Box>
        <Box
          component={Link}
          to="/privacy-policy"
          sx={{ textDecoration: "none" }}
        >
          <Typography
            component={matchesSm ? "div" : "span"}
            sx={{
              color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
            }}
            variant="h3LatoBold"
          >
            Privacy
          </Typography>
        </Box>
        <Box
          mx={3}
          component="span"
          sx={{
            color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
            visibility: { xs: "hidden", sm: "visible" },
          }}
        >
          |
        </Box>
        <Box component={Link} to="/contact-us" sx={{ textDecoration: "none" }}>
          <Typography
            component={matchesSm ? "div" : "span"}
            sx={{
              color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
            }}
            variant="h3LatoBold"
          >
            Contact Us
          </Typography>
        </Box>
        <Box
          mx={3}
          component="span"
          sx={{
            color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
            visibility: { xs: "hidden", sm: "visible" },
          }}
        >
          |
        </Box>
        <Box
          component="span"
          sx={{ cursor: "pointer" }}
          onClick={() => getAppSettingsIdentity()}
        >
          <Typography
            component={matchesSm ? "div" : "span"}
            sx={{
              color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
            }}
            variant="h3LatoBold"
          >
            Application Info
          </Typography>
        </Box>
        {!isHCPTemplate && (
          <>
            <Box
              mx={3}
              component="span"
              sx={{
                color: "white",
                visibility: { xs: "hidden", sm: "visible" },
              }}
            >
              |
            </Box>
            <Box
              component={Link}
              to="/savings"
              sx={{ cursor: "pointer", textDecoration: "none" }}
            >
              <Typography
                component={matchesSm ? "div" : "span"}
                sx={{
                  color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                }}
                variant="h3LatoBold"
              >
                Prescriptions
              </Typography>
            </Box>
          </>
        )}
        <Box
          mx={3}
          component="span"
          sx={{
            color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
            visibility: { xs: "hidden", sm: "visible" },
          }}
        >
          |
        </Box>
        <Box component={Link} to="/sitemap" sx={{ textDecoration: "none" }}>
          <Typography
            component={matchesSm ? "div" : "span"}
            sx={{
              color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
            }}
            variant="h3LatoBold"
          >
            Site Map
          </Typography>
        </Box>
        {organizationInfo?.app?.appCode === "CVD" && !matchesSm && (
          <>
            <Box
              mx={3}
              component="span"
              sx={{
                color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                visibility: { xs: "hidden", sm: "visible" },
              }}
            >
              |
            </Box>

            <Box
              sx={{
                textDecoration: "none",
                marginTop: "-15px",
              }}
            >
              <div
                style={{
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <a
                  rel="noreferrer"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                  href={
                    "https://www.facebook.com/profile.php?id=100087056187860"
                  }
                >
                  <img src={fbIcon} alt="fb icon" />
                </a>
                <a
                  rel="noreferrer"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                  href={"https://www.instagram.com/cuverd_rx/"}
                >
                  <img src={instaIcon} alt="fb icon" />
                </a>
                <a
                  rel="noreferrer"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                  href={"https://www.linkedin.com/company/cuverd/"}
                >
                  <img src={linkedInIcon} alt="fb icon" />
                </a>
                <a
                  rel="noreferrer"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                  href={
                    "https://www.youtube.com/channel/UCvYTWeAA0cwHb0juN4kH_tQ"
                  }
                >
                  <img src={youtubeIcon} alt="fb icon" />
                </a>
                <a
                  rel="noreferrer"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                  href={"https://twitter.com/Cuverd_Rx"}
                >
                  <img src={twitterIcon} alt="fb icon" />
                </a>
              </div>
            </Box>
          </>
        )}
      </Grid>

      <Grid
        item
        container
        direction={matchesSm ? undefined : "column"}
        xs={12}
        sm={9}
        lg={10}
        sx={{ textAlign: matchesSm ? "left" : undefined }}
      >
        {organizationInfo?.suffix === "WGN" && (
          <Grid item>
            <Typography
              component="div"
              variant="h2LatoSemiBold"
              sx={{
                color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                fontSize: "12px",
                padding: "5px 10px 15px 0px",
                lineHeight: "20px",
              }}
            >
              The Cuverd® app is administered by Cuverd®. Cuverd® is solely
              responsible for finding prices of third-party discount and
              manufacturer savings cards to use at Walgreens for eligible
              prescriptions. Customers must affirmatively select and present a
              third-party discount or manufacturer savings card in the pharmacy
              to access the lower price, which may be lower than Walgreens’
              retail price or the price charged to customers paying with
              insurance. Third-party discount and manufacturer savings cards are
              NOT insurance. Any drug-specific exclusions are determined by each
              card vendor and not Walgreens. See vendor site for specific terms
              and conditions of that third-party discount or manufacturer
              savings card. Pricing will vary depending on the applicable card,
              drug and participating Walgreens pharmacy location (“Participating
              Pharmacy”). Prices may change at any time. The prices shown are
              estimated; Cuverd® and Walgreens generally have no control over
              the third-party card vendors, and cannot guarantee that the price
              displayed will exactly match the price you receive at the
              Participating Pharmacy. For an exact price, please contact the
              Participating Pharmacy. By using the Cuverd® app, you agree to the
              following{" "}
              <Box
                component={Link}
                to="/terms-and-conditions"
                sx={{
                  textDecoration: "underline",
                  textDecorationColor: "#fff",
                }}
              >
                <Typography
                  component={matchesSm ? "div" : "span"}
                  sx={{
                    color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                    fontSize: "12px",
                  }}
                  variant="h2LatoSemiBold"
                >
                  Terms and Conditions.
                </Typography>
              </Box>
            </Typography>
          </Grid>
        )}

        <Grid item>
          <Box pb={1} ref={legitscript2} />

          <Typography
            component="div"
            variant="h2LatoSemiBold"
            sx={{
              color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
              lineHeight: "26px",
            }}
          >
            Cuverd is a trademark of TranspareRx Corp.
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            component="div"
            variant="h2LatoSemiBold"
            sx={{
              color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
              lineHeight: "26px",
            }}
          >
            &copy;{(new Date().getFullYear())} TranspareRx Corp. All rights reserved.
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            variant="h2LatoSemiBold"
            sx={{
              color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
              lineHeight: "26px",
            }}
          >
            12250 Tamiami Trail East, Suite 310, Naples, Florida 34113
          </Typography>
        </Grid>
      </Grid>
      {organizationInfo?.app?.appCode === "CVD" && matchesSm && (
        <Grid
          item
          xs={12}
          sm={3}
          lg={2}
          sx={{
            marginTop: "25px",
            marginBottom: "32px",
          }}
        >
          <Box>
            <div
              style={{ height: "50px", display: "flex", alignItems: "center" }}
            >
              <a
                rel="noreferrer"
                target="_blank"
                style={{ textDecoration: "none" }}
                href={"https://www.facebook.com/profile.php?id=100087056187860"}
              >
                <img src={fbIcon} alt="fb icon" />
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                style={{ textDecoration: "none" }}
                href={"https://www.instagram.com/cuverd_rx/"}
              >
                <img src={instaIcon} alt="fb icon" />
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                style={{ textDecoration: "none" }}
                href={"https://www.linkedin.com/company/cuverd/"}
              >
                <img src={linkedInIcon} alt="fb icon" />
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                style={{ textDecoration: "none" }}
                href={
                  "https://www.youtube.com/channel/UCvYTWeAA0cwHb0juN4kH_tQ"
                }
              >
                <img src={youtubeIcon} alt="fb icon" />
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                style={{ textDecoration: "none" }}
                href={"https://twitter.com/Cuverd_Rx"}
              >
                <img src={twitterIcon} alt="fb icon" />
              </a>
            </div>
          </Box>
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sm={3}
        lg={2}
        sx={{
          marginTop: "25px",
          marginBottom: "32px",
        }}
      >
        {organizationInfo && (
          <img
            style={{
              width: matchesSm ? "60%" : "100%",
            }}
            alt="Link to Cuverd Homepage"
            src={
              organizationInfo?.organizationOptionJson?.logoFooterFileName
                ? organizationLogo?.logoFooterBase64
                : Logo
            }
          />
        )}
      </Grid>
      <MessageDialog showPopUp={showAppInfo}>
        <Box>
          {!isHCPTemplate && (
            <Box
              component={Link}
              to="/savings"
              sx={{ maxWidth: "400px", textDecoration: "none" }}
              mb={2}
            >
              <Typography
                variant={matchesMinWidth ? "h3LatoBold" : "h2LatoBold"}
                sx={{ lineHeight: matchesMinWidth ? "24px" : "26px" }}
              >
                Prescriptions
              </Typography>
            </Box>
          )}
          <Box sx={{ maxWidth: "400px" }} mb={2}>
            <Typography
              variant={matchesMinWidth ? "h3LatoBold" : "h2LatoBold"}
              sx={{ lineHeight: matchesMinWidth ? "24px" : "26px" }}
            >
              Application Information
            </Typography>
          </Box>
          <Box>
            <Typography variant="h3LatoBold">
              Version:
              <span style={{ paddingLeft: "12px" }}>{config.version}</span>
            </Typography>
          </Box>
          <Box my={0.6}>
            <Typography variant="h3LatoBold">
              Build:<span style={{ paddingLeft: "12px" }}>{config.build}</span>
            </Typography>
          </Box>
          <Box>
            <Typography variant="h3LatoBold">
              Identifier:
              <span style={{ paddingLeft: "12px", fontSize: "16px" }}>
                {props?.appIdentity}
              </span>
            </Typography>
          </Box>
          <br />
          <br />
          <Box>
            <Typography variant="h3LatoRegular">
              Branch:
              <span style={{ paddingLeft: "12px", fontSize: "14px" }}>
                {version.branch}
              </span>
            </Typography>
          </Box>
          <Box>
            <Typography variant="h3LatoRegular">
              Commit:
              <span style={{ paddingLeft: "12px", fontSize: "14px" }}>
                {version.commit}
              </span>
            </Typography>
          </Box>
          <Box mt={5}>
            <Button
              variant="large"
              onClick={() => {
                resetSettingsIdentity();
                setShowAppInfo(false);
              }}
            >
              Done
            </Button>
          </Box>
        </Box>
      </MessageDialog>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    appIdentity: state.appIdentity.data,
    organizationLogo: state.organizationLogo.data,
    infoStatus: state.appIdentity.status,
    organizationInfo: state.organizationInfo.data,
  };
};

const mapDispatchToProps = {
  getAppSettingsIdentity: () => homeActions.getAppSettingsIdentity(),
  resetSettingsIdentity: () => homeActions.resetSettingsIdentity(),
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterView);
